<template>
  <div class="photo-cell col-12 col-md-6 col-lg-4" :style="{height:photoCellHeight +'px'}" ref="photoCell">
    <div class="photo-cell-inner h-100 p-1" :class="{ favorite: isFavorited }">
      <div class="row no-gutters h-100">
        <div class="col text-center h-100">
          <div class="photo-image point-cursor contain" v-lazy:background-image="smallThumbnailUrl" @click="showPhotoImageModal" style="background-position: bottom;"></div>
        </div>
        <div class="col-auto text-center h-100">
          <div class="d-flex flex-column h-100">
            <div class="photo-no text-center mb-auto">{{photo.photo_no}}</div>
            <div class="">
              <i class="fa fa-search-plus image-zoom-btn" aria-hidden="true" @click="showPhotoImageModal"></i>
            </div>
            <div class="text-center">
              <button class="favorite-operation btn btn-default px-1" data-toggle="modal" v-if="!isFavorited" @click="addCart"><trans-text i18nKey="ui['6'][10]" /> <i class="fa fa-heart" aria-hidden="true"></i></button>
              <button class="favorite-operation btn btn-danger px-1" data-toggle="modal" v-if="isFavorited" @click="removeCart"><trans-text i18nKey="ui['6'][9]" /> <i class="fa fa-heart" aria-hidden="true"></i></button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {dd,store,app} from 'systems/imports'

  export default {
    name:"",
    props:["photo","cart"],

    components: {
    },
    data () {
      return {
        photoCellHeight:null,
        photoImageWrapHeight:null
      }
    },
    watch:{
      "$root.lastAtAdjustLayout"(){
        this.$nextTick()
          .then(()=>{
            this._adjustPhotoCellHeight()
            this.photoImageWrapHeight = 0
            return this.$nextTick()
          }).then(()=>{
          this._adjustphotoImageWrapHeight()
        })
      },
    },
    mounted(){
      this.$nextTick(()=>{
        this._adjustPhotoCellHeight()
        this.$nextTick(()=>{
          this._adjustphotoImageWrapHeight()
        })
      })
    },
    computed:{
      isFavorited(){
        return !app.make("_").isEmpty(this.photo.cart_photos);
      },
      smallThumbnailUrl(){
        let photo = this.photo
        if(!photo){ return null }
        let photoThumbnail = app.make("_").find(photo.photo_thumbnails,(photo_thumbnail)=>{
          return (String(photo_thumbnail.type_code) === "1")
        })
        return photoThumbnail.image_url + '?token='+store.get("token")
      },
    },
    methods:{
      //
      _adjustPhotoCellHeight(){
        this.photoCellHeight = $(this.$refs.photoCell).width() / 2
      },
      _adjustphotoImageWrapHeight(){
        this.photoImageWrapHeight = $(this.$refs.photoImageWrap).height()
      },

      //
      showPhotoImageModal(){
        this.$emit("showPhotoImageModal",this.photo)
      },
      addCart(){
        this.$emit("addCarPhoto",this.photo)
      },
      removeCart(){
        this.$emit("removeCartPhoto",this.photo)
      }
    }
  }
</script>


<style lang="scss" scoped>
  @import "~scss/_variables";

  .favorite-operation{
    padding-top:.1rem;
    padding-bottom:.1rem;
    @media(max-width: map-get($grid-breakpoints, "lg") - 1) {
      padding-top:.4rem;
      padding-bottom:.4rem;
    }
  }

  .photo-cell {
    margin-bottom: 2px;

    .photo-cell-inner {
      background-color: #fff;
      border: 2px solid #a8a5a3;
      border-radius: .5rem;
      &.favorite {
        border: 2px solid #ec5c45;
      }
      .photo-no {
        font-size: 0.8rem;
      }
      .image-zoom-btn{
        color: #82ba1d;
        cursor: pointer;
        padding-bottom: .5rem;
        font-size:1.2rem;
        @media(max-width: map-get($grid-breakpoints, "lg") - 1) {
          font-size:2rem;
        }
      }
      .favorite-operation{
        font-size:0.8rem;
        vertical-align: bottom;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// GroupHorizonPhoto.vue?6738d870